import * as yup from "yup";
import {
  descriptionValidator,
  pushCenterNameValidator,
} from "./commonValidators";

export const addPushCenterValidator = yup.object({
  name: pushCenterNameValidator,
  description: descriptionValidator,
});
